module.exports = new __parcel__URL__("editor.worker.1d787ec7.js").toString();